const base = "https://s.geilicdn.com/im/emoji/kb-emoji-";
const ext = ".png";
function com( name ) {
  return base + name + ext;
}
export default {
  "[微笑]": com("E056"),
  "[愉快]": com("E056"),
  "[呲牙]": com("E404"),
  "[惊讶]": com("E107"),
  "[色]": com("E106"),
  "[流汗]": com("E108"),
  "[飞吻]": com("E418"),
  "[流泪]": com("E411"),
  "[亲亲]": com("E417"),
  "[难过]": com("E413"),
  "[惬意]": com("E40A"),
  "[得意]": com("E402"),
  "[笑哭]": com("E412"),
  "[吐舌]": com("E409"),
  "[发呆]": com("E40D"),
  "[生气]": com("E059"),
  "[失落]": com("E403"),
  "[傻笑]": com("E415"),
  "[淘气]": com("E105"),
  "[害羞]": com("E414"),
  "[眨眼]": com("E405"),
  "[笑脸]": com("E057"),
  "[眼花]": com("E410"),
  "[委屈]": com("E058"),
  "[抓狂]": com("E407"),
  "[鄙视]": com("E40E"),
  "[生病]": com("E40C"),
  "[困了]": com("E408"),
  "[震惊]": com("E40B"),
  "[冷汗]": com("E40F"),
  "[愤怒]": com("E416"),
  "[邪恶]": com("E11A"),
  "[晚安]": com("E13C"),
  "[土豪]": com("E12F"),
  "[酷]": com("E214"),
  "[玫瑰]": com("E032"),
  "[嘴唇]": com("E003"),
  "[眼睛]": com("E419"),
  "[赞]": com("E00E"),
  "[ok]": com("E420"),
  "[胜利]": com("E011"),
  "[鼓掌]": com("E41F"),
  "[双手赞成]": com("E427"),
  "[双手合十]": com("E41D"),
  "[便便]": com("E05A"),
  "[心]": com("E022"),
  "[心碎]": com("E023"),
  "[丘比特]": com("E329"),
  "[爱心]": com("E327"),
  "[心动]": com("E328"),
  "[叹号]": com("E337"),
  "[疑问]": com("E336"),
  "[闪烁]": com("E32E"),
  "[星星]": com("E335"),
  "[水滴]": com("E331"),
  "[火]": com("E11D"),
  "[爱情]": com("E111"),
  "[牵手]": com("E428"),
  "[起来嗨]": com("E51F"),
  "[跳舞]": com("E429"),
  "[钻石]": com("E035"),
  "[干杯]": com("E30C"),
  "[咖啡]": com("E045"),
  "[礼盒]": com("E437"),
  "[鬼脸]": com("E11B"),
  "[圣诞老人]": com("E448"),
  "[圣诞树]": com("E033"),
  "[礼物]": com("E112"),
  "[庆祝]": com("E312"),
  "[气球]": com("E310"),
  "[唱歌]": com("E03C"),
  "[比基尼]": com("E322"),
  "[冰激凌]": com("E33A"),
  "[蛋糕]": com("E34B"),
  "[流星]": com("E44B"),
  "[焰火]": com("E117"),
  "[彩虹]": com("E44C"),
  "[备忘]": com("E301"),
  "[秘密]": com("E315"),
  "[男人]": com("E138"),
  "[女人]": com("E139")
}


/** WEBPACK FOOTER **
 ** ./lib/emoji-map.js
 **/